export default __webpack_public_path__ + "static/media/ic_search.c6bf8f43.svg";